import React, { Component } from "react";
import CurrencyFormat from "react-currency-format";
import { Col, Row } from "antd";

import "./styles.css";

export default class PastaInfos extends Component {
  /** Mostra dados da pasta no cabeçalho do filtro */
  render() {
    return (
      <div className="infos__container">
        <Row gutter={8}>
          <Col span={8}>
            <div className="infos__info">
              Pasta: <b>{this.props.pasta.pasta_to_filter.pasta}</b>
            </div>
          </Col>

          <Col span={8}>
            <div className="infos__info">
              Valor: R${" "}
              <b>
                <CurrencyFormat
                  value={this.props.pasta.pasta_to_filter.vlr_ressarcimento}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                />
              </b>
            </div>
          </Col>

          <Col span={8}>
            <div className="infos__info">
              Data sinistro:{" "}
              <b>
                {
                  new Date(this.props.pasta.pasta_to_filter.data_sinistro)
                    .toLocaleString()
                    .split(" ")[0]
                }
              </b>
            </div>
          </Col>

          <Col span={8}>
            <div className="infos__info">
              Nº sinistro:{" "}
              <b>{this.props.pasta.pasta_to_filter.num_sinistro}</b>
            </div>
          </Col>

          <Col span={8}>
            <div className="infos__info">
              B.O:{" "}
              <b>{this.props.pasta.pasta_to_filter.tem_bo ? "Sim" : "Não"}</b>
            </div>
          </Col>

          <Col span={8}>
            <div className="infos__info">
              Sinistro associado:{" "}
              <b>{this.props.pasta.sinistro_associado ? "Sim" : "Não"}</b>
            </div>
          </Col>

          <Col span={24}>
            <div className="col-sm-12 infos__sinistro">
              Aviso de sinistro:
              <p>{this.props.pasta.pasta_to_filter.descricao_sinistro}</p>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/PastaInfos/index.js